import { backend } from 'api/clients';

export const getReport = () => backend.get('/api/v1/idm-reports-patients/overview');
